import {
  AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, Output,
  EventEmitter, OnDestroy, ViewChild, ViewEncapsulation
} from '@angular/core';

import { fromEvent, Subscription } from 'rxjs';

import { SdHtmlComponent, SdSkeletonComponent, SkeletonAppearanceEnum } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-product-seller',
  templateUrl: './product-seller.component.html',
  styleUrls: ['./product-seller.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdSkeletonComponent,
    SdHtmlComponent
  ]
})
export class SdProductSellerComponent implements AfterViewInit, OnDestroy {
  @Input()
  isLoading = false;

  @Input()
  text: string;

  @Input()
  textSoldBy: string;

  @Input()
  horizontalParentLayout = false;

  @HostBinding('class.is-small')
  @Input()
  isSmall = true;

  @ViewChild('paragraph', { read: ElementRef })
  paragraph: ElementRef;

  @Output()
  toggleModalChange = new EventEmitter<boolean>();

  SkeletonAppearanceEnum = SkeletonAppearanceEnum;
  subscriptions = new Subscription();
  isOpened = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (this.paragraph) {
      setTimeout(() => {
        const link = this.paragraph.nativeElement.getElementsByTagName('a')[0];
        if (link) {
          this.subscriptions.add(
            fromEvent(link, 'click').subscribe(() => {
              this.toggleModal();
              this.cdRef.markForCheck();
            })
          );
        }
      }, 0);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private toggleModal(): void {
    this.isOpened = !this.isOpened;
    this.toggleModalChange.emit(this.isOpened);
  }
}
